export enum LibraryFileType {
  FILE_BASED = 'FILE_BASED',
  URL_BASED = 'URL_BASED',
}
